import { render } from "./AccountEdit.vue?vue&type=template&id=6f701b77&scoped=true"
import script from "./AccountEdit.vue?vue&type=script&lang=js"
export * from "./AccountEdit.vue?vue&type=script&lang=js"

import "./AccountEdit.vue?vue&type=style&index=0&id=6f701b77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f701b77"]])

export default __exports__